import { withSpinLock } from './SpinBlockingHOC';
import TooltipIconButton from '../Buttons/TooltipIconButton';

export default withSpinLock(TooltipIconButton);